import { render } from "./new_staff_form.vue?vue&type=template&id=1f72f62f&scoped=true"
import script from "./new_staff_form.vue?vue&type=script&lang=js"
export * from "./new_staff_form.vue?vue&type=script&lang=js"

import "./new_staff_form.vue?vue&type=style&index=0&id=1f72f62f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f72f62f"]])

export default __exports__